import React, { useEffect, useRef } from 'react';
import { ExternalLink, TrendingUp, Zap, Target, Users, BookOpen, Trophy } from 'lucide-react';
import { testimonials, benefits } from '../data/mockData';

const LandingPage = () => {
  const testimonialsRef = useRef(null);

  useEffect(() => {
    // Duplicate testimonials for infinite scroll
    if (testimonialsRef.current) {
      const container = testimonialsRef.current;
      const items = container.children;
      const itemWidth = items[0]?.offsetWidth || 0;
      
      // Clone testimonials for seamless loop
      Array.from(items).forEach(item => {
        const clone = item.cloneNode(true);
        container.appendChild(clone);
      });
    }
  }, []);

  return (
    <div className="landing-page">
      {/* Floating particles background */}
      <div className="particles-container">
        {[...Array(30)].map((_, i) => (
          <div key={i} className="particle" style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 20}s`,
            animationDuration: `${15 + Math.random() * 10}s`
          }}></div>
        ))}
      </div>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-glow"></div>
        <div className="hero-content">
          <h1 className="hero-title">
            Create Your Quotex Account & Join{' '}
            <span className="gradient-text">BigBull VIP</span>
          </h1>
          <p className="hero-subtitle">
            Access a premium trading ecosystem powered by AI precision, high-accuracy signals, 
            and a results-driven VIP community.
          </p>
          
          <div className="cta-buttons">
            <a 
              href="https://market-qx.trade/?lid=347430" 
              target="_blank" 
              rel="noopener noreferrer"
              className="cta-primary"
            >
              <span>Create Quotex Account (Global Users)</span>
              <ExternalLink size={18} />
            </a>
            <a 
              href="https://qxbroker.com/en/sign-up?lid=347430" 
              target="_blank" 
              rel="noopener noreferrer"
              className="cta-secondary"
            >
              <span>Create Account (Pakistan & Bangladesh)</span>
              <ExternalLink size={18} />
            </a>
          </div>

          <p className="helper-text">
            If the link is not working, contact us on{' '}
            <a 
              href="https://t.me/Bigbullamitfx" 
              target="_blank" 
              rel="noopener noreferrer"
              className="telegram-link"
            >
              Telegram
            </a>
          </p>
        </div>
      </section>

      {/* Profit Proof Section */}
      <section className="profit-section">
        <div className="profit-card">
          <div className="profit-glow"></div>
          <div className="profit-content">
            <div className="profit-number">
              <TrendingUp size={40} className="profit-icon" />
              <span className="amount">$1.8 Million+</span>
            </div>
            <h2 className="profit-title">Profit Generated</h2>
            <p className="profit-description">
              Our VIP members generated over $1.8M in the last year using our advanced bot and VIP signals.
              Average monthly profit: <strong>$1000 – $10000+</strong> depending on capital and risk.
            </p>
            <p className="profit-cta">Join VIP to achieve similar results</p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <h2 className="section-title">What Our Members Say</h2>
        <div className="testimonials-wrapper">
          <div className="testimonials-track" ref={testimonialsRef}>
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-content">
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  <p className="testimonial-author">— {testimonial.author}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <h2 className="section-title">What You Get Inside BigBull VIP</h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div key={index} className="benefit-card">
                <div className="benefit-icon-wrapper">
                  <Icon size={32} className="benefit-icon" />
                </div>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* Risk Disclaimer */}
      <section className="disclaimer-section">
        <div className="disclaimer-card">
          <h3 className="disclaimer-title">⚠️ Risk Disclaimer</h3>
          <p className="disclaimer-text">
            Binary trading involves high risk. You may lose all your capital. Trade responsibly 
            and only invest what you can afford to lose. Past performance does not guarantee future results.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p className="footer-text">Join our Telegram channel for updates and growth</p>
        <a 
          href="https://t.me/+2D1dq8ak4I01MWM1" 
          target="_blank" 
          rel="noopener noreferrer"
          className="footer-link"
        >
          <ExternalLink size={16} />
          <span>Join Telegram Channel</span>
        </a>
        <p className="footer-copyright">© 2024 BigBull VIP. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default LandingPage;
